import { EditPencil, Plus, Cancel, CheckCircledOutline, CarOutline } from 'iconoir-react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getAllVehicles, updateVehicleById } from '../../../redux_store/vehicles/vehicle_thunk'
import Button from '../../templates/Button'
import LoadingModal from '../../templates/modals/LoadingModal'
import { SUCCESS, FAIL, LOADING } from '../../../redux_store/actionTypes';
import toast from '../../templates/ToastMessage'
import { convertFromPesewasToCedis } from '../../../utils'

const VehiclesPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { vehicles, status, message } = useSelector((state) => state.vehicle);

  useEffect(() => {
    if (status === FAIL) {
      toast({ message, status });
    } else if (status === SUCCESS) {
      toast({ message, status });
      dispatch(getAllVehicles());
    }
    // eslint-disable-next-line
  }, [status]);

  useEffect(() => {
    dispatch(getAllVehicles());
    // eslint-disable-next-line
  }, []);

  return (
    <div className='space-y-6'>
      {status === LOADING && <LoadingModal message={'Loading data...'} />}

      {/* Page Header */}
      <div className='flex items-center justify-between'>
        <div>
          <h1 className='text-2xl font-bold text-surface-800'>Vehicle Management</h1>
          <p className='text-surface-500 mt-1'>Manage registered vehicle types and pricing</p>
        </div>
        <Button
          onClick={() => navigate('/vehicles/register')}
          label={'Register Vehicle'}
          variant="primary"
          icon={<Plus strokeWidth={2} className='w-4 h-4' />}
        />
      </div>

      {/* Vehicles Table */}
      <div className='card p-0 overflow-hidden'>
        <table className="table-modern">
          <thead>
            <tr>
              <th>Vehicle Type</th>
              <th>Base Fee</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {vehicles && vehicles.length > 0 ? vehicles.map((vehicle, index) =>
              <tr key={vehicle.id || index}>
                <td>
                  <div className="flex items-center gap-3">
                    <img
                      className="w-12 h-12 rounded-xl object-cover ring-2 ring-surface-100"
                      src={vehicle.image}
                      alt={vehicle.vehicle_types}
                      loading="lazy"
                    />
                    <div>
                      <p className="font-semibold text-surface-800">
                        {vehicle.vehicle_types}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  <span className='font-semibold text-surface-800'>
                    GH₵ {convertFromPesewasToCedis(vehicle.base_fee).toFixed(2)}
                  </span>
                </td>
                <td>
                  {vehicle.active ? (
                    <span className='badge-success'>
                      <span className='w-1.5 h-1.5 rounded-full bg-emerald-500' />
                      Active
                    </span>
                  ) : (
                    <span className='badge-danger'>
                      <span className='w-1.5 h-1.5 rounded-full bg-rose-500' />
                      Inactive
                    </span>
                  )}
                </td>
                <td>
                  <div className='flex items-center gap-2'>
                    <button
                      onClick={() => navigate(`/vehicles/edit/${vehicle.id}`)}
                      className='btn-ghost p-2 rounded-lg'
                      title='Edit Vehicle'
                    >
                      <EditPencil strokeWidth={2} className='w-4 h-4' />
                    </button>
                    {vehicle.active ? (
                      <button
                        onClick={() => {
                          dispatch(updateVehicleById({
                            id: vehicle.id, details: { active: false }
                          }));
                        }}
                        className='btn-ghost p-2 rounded-lg text-rose-500 hover:text-rose-600 hover:bg-rose-50'
                        title='Deactivate'
                      >
                        <Cancel strokeWidth={2} className='w-4 h-4' />
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          dispatch(updateVehicleById({
                            id: vehicle.id, details: { active: true }
                          }));
                        }}
                        className='btn-ghost p-2 rounded-lg text-emerald-500 hover:text-emerald-600 hover:bg-emerald-50'
                        title='Activate'
                      >
                        <CheckCircledOutline strokeWidth={2} className='w-4 h-4' />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ) :
              <tr>
                <td colSpan={4} className="text-center py-12">
                  <div className='flex flex-col items-center gap-3'>
                    <div className='w-16 h-16 rounded-2xl bg-surface-100 flex items-center justify-center'>
                      <CarOutline strokeWidth={1.5} className='w-8 h-8 text-surface-400' />
                    </div>
                    <div>
                      <p className='font-medium text-surface-600'>No vehicles registered</p>
                      <p className='text-sm text-surface-400'>Add your first vehicle type to get started</p>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default VehiclesPage
